import { render, staticRenderFns } from "./SectionsList.vue?vue&type=template&id=55fe7944"
import script from "./SectionsList.vue?vue&type=script&lang=js"
export * from "./SectionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports